import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'

import api from '../services'
import utils from '../utils'
const { $, FE } = utils

@inject('carInfo')
@inject('cityInfo')
@inject('lzLayState')
@observer
export default class LzLay extends Component {
  constructor(props){
    super(props)
    this.state = {
      proCheck: true,
      mobile: ''
    }

    this.inputRef = React.createRef()

    this.submitInfo = this.submitInfo.bind(this)
    this.togglePro = this.togglePro.bind(this)
  }

  togglePro(){
    this.setState({
      proCheck: !this.state.proCheck
    })
  }

  submitInfo(){
    let { carInfo, cityInfo, lzLayState } = this.props,sending = false,phone = this.inputRef.current.value,
    showInfo = carInfo.info.seriesName?carInfo.info:carInfo.preferCar,
    params = {
      _appid: 'mall',
      name: '红包集市',
      mobile: FE.Utils.saleLeadsEncryptPhone(phone),
      brandId : showInfo.brandId,
      seriesId : showInfo.seriesId,
      pvId: FE.Utils.readCookie("mpvareaid") || 0,
      deviceType: 2,
      mpvAreaId: FE.Utils.readCookie("mpvareaid") || 0,
      loadId: window.pageLoadId,
      visitsAreaCookie: FE.Utils.readCookie("ref") || 0,

      activityId: 338,
      activityType: 338,
      activityName: '红包集市',
      sourceType: 151,
      stageType: 14,
      originType: 1,

      cityId: cityInfo.info.cityId,
      gpsCityId: FE.Utils.getCityId() ||0,
      businessUnitType: 2//业务线来源,全部:0;自营:1;商家:2
    }

    //个人声明必选
    if(!this.state.proCheck && lzLayState.type === 'zsyh'){
      $.toast({
        text: '请先同意《个人信息保护声明》',
        duration: 2000,
      })
      return
    }
    //车系必选
    if(!params.seriesId){
      $.toast({
        text: '请先选择车系',
        duration: 2000
      })
      return
    }
    //手机号校验
    if(!(/^1\d{10}$/).test(phone)){
      $.toast({
        text: '请输入正确格式的手机号',
        duration: 2000,
      })
      return
    }

    if(sending){
      $.toast({
        text: '提交中请稍后',
        duration: 2000,
      })
      return
    }
    sending = true

    api.saleLead(params)
      .then((data) => {
        if (data.returncode === 0) {
          lzLayState.hide()
          carInfo.clearSelCar()
          $.toast({
            text: '提交成功',
            duration: 2000,
          })
        }else {
          $.toast({
            text: data.message,
            duration: 2000,
          })
        }
      })
      .catch((err) => {
        $.toast({
          text: err.message,
          duration: 2000,
        })
      })
      .finally(() => sending = false)
  }

  componentDidMount(){
    api.getUserPhone()
      .then((data) => {
        if(data.returncode === 0) {
          //用户手机号反显
          this.setState({
            mobile: data.result
          })
        }
      })
      .catch(() => {})
  }

  render(){
    let { carInfo, lzLayState } = this.props,{ hide, isShow, type } = lzLayState,
    showInfo = carInfo.info.seriesName?carInfo.info:carInfo.preferCar
    
    return(
      <div className={ isShow?'layer':'layer fn-hide' }>
        <div className='layer-form'>
          <span className='layer-close' onClick={() => {
            hide()
            carInfo.clearSelCar()
          }}></span>

          <p className={type === 'zsyh'?'layer-title':'layer-title fn-hide'}>填写资料</p>
          <p className={type === 'search'?'layer-title':'layer-title fn-hide'}>
            很遗憾，没有找到搜索结果<br/>请留下您的意向车系
          </p>

          <div className='layer-line' onClick={carInfo.show}>
            <span className='layer-line-title'>车系</span>
            <p className='layer-line-input'>{ showInfo.seriesName || '请选择车系' }</p>
            <span className='layer-line-angle'></span>
          </div>

          <div className='layer-line'>
            <span className='layer-line-title'>手机号</span>
            <input type='tel' maxLength='11'
                  className='layer-line-input'
                  placeholder='请输入您的手机号'
                  ref = {this.inputRef}
                  defaultValue={this.state.mobile} />
            <span className='layer-line-xg'></span>
          </div>
          
          <div className={type === 'zsyh'?'layer-protocol':'layer-protocol fn-hide'}>
            <div>
              <span className={this.state.proCheck?'layer-check agreed':'layer-check'} onClick={this.togglePro}></span>
              我同意<a href={FE.Utils.getHref("https://m.mall.autohome.com.cn/subject/2018/5/grxxsm/")}>《个人信息保护声明》</a>
            </div>
            <p>汽车之家客服人员会尽快与您取得联系，请您保持手机畅通</p>
          </div>

          <p className='layer-submit' onClick={this.submitInfo}>提交</p>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/LzLay.js